import React, { HTMLProps, ReactNode } from 'react';

function CustomButton(props: Prop) {
  const {
    customSize = 'sm',
    customType = 'deploy',
    onClick = () => {},
    icon = <></>,
    iconPosition = 'left',
    className,
    text = 'button',
    disabled = false,
    id,
    ...rest
  } = props;

  return (
    <a className={'btn flex items-center justify-center ' + getSize(customSize) + ' ' + getType(customType) + ' ' + className} onClick={onClick} {...rest}>
      {iconPosition == 'left' && (
        <div className={'w-full h-full flex items-center justify-start ' + getIcon(customType)}>
          {icon}
          <p className={'text-2xs w-full h-full flex justify-center items-center'}>{text}</p>
        </div>
      )}

      {iconPosition == 'right' && (
        <div className={'h-full flex items-center justify-center ' + getIcon(customType)}>
          <p className={'text-2xs w-full h-full flex justify-center items-center mr-2'}>{text}</p>
          {icon}
        </div>
      )}
    </a>
  );
}

function getSize(customSize: string) {
  switch (customSize) {
    case 'sm':
      return 'btn-sm';
    case 'md':
      return 'btn-md';
    case 'lg':
      return 'btn-lg';
    default:
      return 'btn-sm';
  }
}

function getType(customType: string) {
  switch (customType) {
    case 'deploy':
      return 'btn-deploy';
    case 'undeploy':
      return 'btn-undeploy';
    case 'save':
      return 'btn-save';
    case 'remove':
      return 'btn-remove ';
    case 'redeploy':
      return 'btn-deploy ';
  }
}

function getIcon(customType: string) {
  switch (customType) {
    case 'deploy':
      return 'btn-deploy-icon';
    case 'undeploy':
      return 'btn-undeploy-icon';
    case 'save':
      return 'btn-save-icon';
    case 'remove':
      return 'btn-undeploy-icon ';
    case 'redeploy':
      return 'btn-deploy-icon ';
  }
}

export default CustomButton;

interface Prop extends HTMLProps<HTMLAnchorElement> {
  customSize?: 'sm' | 'md' | 'lg';
  customType?: 'deploy' | 'undeploy' | 'redeploy' | 'save' | 'remove';
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  text?: string;
}
